import { DepositsOffer, DepositsPartner, LoanOffer, LoanOriginator, Offer, SpecialOffer } from 'embed/constants/models'

/**
 * Filter recommended offers and sort them
 * This is tested in SelectQualifiedLoan/container.test.tsx
 * @param {LoanOffer[]} offers
 * @returns {LoanOffer[]}
 */
export const filterRecommendedOffers = (offers: LoanOffer[]) =>
  offers
    .filter((offer) => offer.preApproved || offer.preQualified)
    .sort((a, b) => {
      if (a.maxApr && b.maxApr && a.maxApr > 36 && b.maxApr < 36) {
        return 1
      } else if (a.maxApr && b.maxApr && a.maxApr < 36 && b.maxApr > 36) {
        return -1
      } else {
        // Sort by rec score unless they're the same, then sort by APR
        return b.recommendationScore !== a.recommendationScore
          ? (b.recommendationScore || 0) - (a.recommendationScore || 0)
          : (a.maxApr || 0) - (b.maxApr || 0)
      }
    })

export const filterUniqueLoanOffersByCompanyUuid = (offers: LoanOffer[]) =>
  Array.from(
    offers
      .reduce<Map<LoanOriginator['companyUuid'], LoanOffer>>((acc, offer) => {
        if (offer.originator && !acc.has(offer.originator.companyUuid)) {
          acc.set(offer.originator.companyUuid, offer)
        }
        return acc
      }, new Map())
      .values(),
  )

export const filterUniqueOffersByUuid = (offers: Offer[]) =>
  Array.from(
    offers
      .reduce<Map<Offer['uuid'], Offer>>((acc, offer) => {
        if (!acc.has(offer.uuid)) {
          acc.set(offer.uuid, offer)
        }
        return acc
      }, new Map())
      .values(),
  )

export const filterUniqueDepositsOffersByPartnerUuid = (offers: DepositsOffer[]) =>
  Array.from(
    offers
      .reduce<Map<DepositsPartner['uuid'], DepositsOffer>>((acc, offer) => {
        if (offer.partner?.uuid && !acc.has(offer.partner.uuid)) {
          acc.set(offer.partner.uuid, offer)
        }
        return acc
      }, new Map())
      .values(),
  )

export const getExclusiveSpecialOffers = (offers: SpecialOffer[]) =>
  offers.filter((offer) => ['Pick A Lender API', 'Pioneer'].indexOf(offer.partnerName) !== -1)

export const getOffersByLenderName = (offers, name: string) => offers.filter((offer) => offer.partnerName === name)
